// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../reason/clients/components/Labels.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var OwnBuyerNeedStatusLabel_buyerNeedV5_graphql = require("../../__generated__/OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.bs.js");

var convertFragment = OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(OwnBuyerNeedStatusLabel_buyerNeedV5_graphql.node, convertFragment, fRef);
}

var BuyerNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function OwnBuyerNeedStatusLabel$WithoutErrorBoundary(props) {
  var match = use(props.buyerNeed);
  var status = match.status;
  switch (status.__typename) {
    case "ActiveBuyerNeed" :
        if (!status.isRenewable) {
          return JsxRuntime.jsx(Labels.ActiveStatusLabel.make, {});
        }
        var daysLeft = DateFns.differenceInCalendarDays(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(status.activeUntil)), new Date());
        return JsxRuntime.jsx(Labels.ExpiringStatusLabel.make, {
                    expiringIn: Labels.stringOfExpiring(daysLeft)
                  });
    case "ExpiredBuyerNeed" :
        return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "InContractBuyerNeed" :
        return JsxRuntime.jsx(Labels.InContractLabel.make, {});
    case "PurchasedBuyerNeed" :
        return JsxRuntime.jsx(Labels.PurchasedLabel.make, {});
    case "WithdrawnBuyerNeed" :
        return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
        return null;
    
  }
}

var WithoutErrorBoundary = {
  make: OwnBuyerNeedStatusLabel$WithoutErrorBoundary
};

function OwnBuyerNeedStatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "buyerNeed status",
              children: JsxRuntime.jsx(OwnBuyerNeedStatusLabel$WithoutErrorBoundary, {
                    buyerNeed: props.buyerNeed
                  })
            });
}

var make = OwnBuyerNeedStatusLabel;

exports.BuyerNeedFragment = BuyerNeedFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
